exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".round-box[data-v-9cab3a4a]{width:8px;height:8px;border-radius:50%;margin-right:8px}.long-text[data-v-9cab3a4a]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.startTime[data-v-9cab3a4a]{font-weight:400;font-size:13px;color:#969696;margin-top:4px}.box-card[data-v-9cab3a4a]{border-radius:8px}", ""]);

// exports
